module.exports = __webpack_public_path__ + "static/media/400023_02.ba1a88f6.png";